export function toPercentage(num: number, fractionDigits: number = 0): string {
  return `${(num * 100).toFixed(fractionDigits)}`;
}
